import Cookie from "./client/Cookie";
import {
    REGION_COOKIE,
    COUNTRY_COOKIE,
    EXPERIENCE_COOKIE,
} from "../constants/Cookie";
import * as EnvUtil from "./EnvUtil";
import UserExperience from "./UserExperience";

const AMER_EXPERIENCE_CODE = "AMER";
const APAC_EXPERIENCE_CODE = "APAC";
const UK_EXPERIENCE_CODE = "EUR";
const MIDEAST_EXPERIENCE_CODE = "MIDEAST";
const AFRICA_EXPERIENCE_CODE = "AFRICA";
const CANADA_EXPERIENCE_CODE = "CANADA";
const AUSTRALIA_EXPERIENCE_CODE = "AUSTRALIA";
const FALLBACK_EXPERIENCE_CODE = AMER_EXPERIENCE_CODE;

const regionCookieToRegionCode = {
    EUROPE: UK_EXPERIENCE_CODE,
    US: AMER_EXPERIENCE_CODE,
    ASIA: APAC_EXPERIENCE_CODE,
    MIDEAST: MIDEAST_EXPERIENCE_CODE,
    AFRICA: AFRICA_EXPERIENCE_CODE,
};

const countryCookieToRegionCode = {
    CA: CANADA_EXPERIENCE_CODE,
    AU: AUSTRALIA_EXPERIENCE_CODE,
};

const UserRegionInfo = {
    getRegion() {
        if (!EnvUtil.isBrowser()) {
            return FALLBACK_EXPERIENCE_CODE;
        }

        let region = Cookie.get(EXPERIENCE_COOKIE);
        if (region) {
            return region;
        }

        region = UserRegionInfo._getRegionFromCountryCookie();
        if (region) {
            return region;
        }

        region = UserRegionInfo._getRegionFromRegionCookie();

        return region || FALLBACK_EXPERIENCE_CODE;
    },

    _getRegionFromCountryCookie() {
        const cookieVal = Cookie.get(COUNTRY_COOKIE);
        const countryCode =
            cookieVal && countryCookieToRegionCode[cookieVal.toUpperCase()];
        return countryCode || null;
    },

    _getRegionFromRegionCookie() {
        const cookieVal = Cookie.get(REGION_COOKIE);
        const regionCode =
            cookieVal && regionCookieToRegionCode[cookieVal.toUpperCase()];
        return regionCode || null;
    },

    getLocalRegion({ channels }) {
        const regionVal = UserRegionInfo.getRegion();
        return new UserExperience(channels).getLiveChannelIdFromRegion(
            regionVal
        );
    },
};

export default UserRegionInfo;

export const {
    getRegion,
    _getRegionFromCountryCookie,
    _getRegionFromRegionCookie,
    getLocalRegion,
} = UserRegionInfo;
